import { createFileRoute } from "@tanstack/react-router";
import { AIIssuesPage } from "@corpuscomplete/web/modules/admin/ai-issue/pages/ai-issues";

export const Route = createFileRoute("/_admin/admin/ai-issues/")({
  component: AIIssuesPage,
});
